import React from 'react';
import { View } from 'react-native';
import { postItemStrings } from '@/constants/residents/marketplaceStrings';
import { POST_ITEM_PICKUP_OPTIONS } from '@/constants/residents/marketplaceConstants';
import { PostItemFormData, PostItemPickupOption, getPostItemPickupDisplayText } from '@/types/residents/marketplaceListing';
import { StepHeader, SelectableOption, postItemStyles } from './shared';

interface StepPickupPreferencesProps {
  formData: PostItemFormData;
  onFormChange: (updates: Partial<PostItemFormData>) => void;
}

export const StepPickupPreferences: React.FC<StepPickupPreferencesProps> = ({
  formData,
  onFormChange,
}) => {
  const handleToggleOption = (option: PostItemPickupOption) => {
    const currentOptions = formData.pickupOptions;
    const isSelected = currentOptions.includes(option);
    
    if (isSelected) {
      // Remove the option
      onFormChange({
        pickupOptions: currentOptions.filter(o => o !== option),
      });
    } else {
      // Add the option
      onFormChange({
        pickupOptions: [...currentOptions, option],
      });
    }
  };

  return (
    <View style={postItemStyles.container}>
      <StepHeader title={postItemStrings.pickupPreferences} />
      
      <View style={postItemStyles.contentWithBottomPadding}>
        <View style={postItemStyles.optionsList}>
          {POST_ITEM_PICKUP_OPTIONS.map((option) => (
            <SelectableOption
              key={option}
              label={getPostItemPickupDisplayText(option)}
              isSelected={formData.pickupOptions.includes(option)}
              onPress={() => handleToggleOption(option)}
              type="checkbox"
            />
          ))}
        </View>
      </View>
    </View>
  );
};
